import { render } from "./LabaRugi.vue?vue&type=template&id=1fe6df42&scoped=true"
import script from "./LabaRugi.vue?vue&type=script&lang=js"
export * from "./LabaRugi.vue?vue&type=script&lang=js"

import "./LabaRugi.vue?vue&type=style&index=0&id=1fe6df42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe6df42"]])

export default __exports__